/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoFusionModelsCustomProductDesignHoop
 */
export interface MelcoFusionModelsCustomProductDesignHoop {
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsCustomProductDesignHoop
     */
    backward_compatibility_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsCustomProductDesignHoop
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsCustomProductDesignHoop
     */
    name?: string | null;
}

export function MelcoFusionModelsCustomProductDesignHoopFromJSON(json: any): MelcoFusionModelsCustomProductDesignHoop {
    return MelcoFusionModelsCustomProductDesignHoopFromJSONTyped(json, false);
}

export function MelcoFusionModelsCustomProductDesignHoopFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoFusionModelsCustomProductDesignHoop {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'backward_compatibility_id': !exists(json, 'backward_compatibility_id') ? undefined : json['backward_compatibility_id'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function MelcoFusionModelsCustomProductDesignHoopToJSON(value?: MelcoFusionModelsCustomProductDesignHoop | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'backward_compatibility_id': value.backward_compatibility_id,
        'id': value.id,
        'name': value.name,
    };
}


